
        // Mockups configuration loaded client-side
        let mockupsConfig = {};
        const settings = { site_name: 'Djebs Official' };
        let currentProductType = 'tshirt'; // Default product type
        const myAssetUrl = "//djebsofficial.store/cdn/shop/t/4/assets/mockups_config.json?v=14205939934068947851774654839";

        async function loadMockupsConfig() {
            try {
                const res = await fetch(myAssetUrl, { cache: 'no-cache' });
                if (!res.ok) throw new Error(`Failed to load config: ${res.status}`);
                return await res.json();
            } catch (err) {
                console.error('Mockups config load failed', err);
                return {};
            }
        }
        
        // Get primary color from CSS
        const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--accent-color').trim() || '#A57B3F';
        
        // Initialize Fabric.js Canvas
        const canvasContainer = document.querySelector('.m-designer-canvas-container');
        let canvasWidth = canvasContainer.offsetWidth;
        let canvasHeight = canvasContainer.offsetHeight;
        
        const canvas = new fabric.Canvas('designCanvas', {
            width: canvasWidth,
            height: canvasHeight,
            backgroundColor: '#ffffff',
            // Customize selection controls
            selectionColor: primaryColor + '20',
            selectionBorderColor: primaryColor,
            selectionLineWidth: 2,
            borderColor: primaryColor,
            cornerColor: primaryColor,
            cornerStyle: 'circle',
            cornerSize: 10,
            transparentCorners: false,
            borderDashArray: [5, 5]
        });

        // Persist custom view metadata when serializing objects
        const customProps = ['viewSide', 'relativeX', 'relativeY'];
        const origToObject = fabric.Object.prototype.toObject;
        fabric.Object.prototype.toObject = function(props) {
            return origToObject.call(this, (props || []).concat(customProps));
        };

        // Mockup images (support multiple views)
        let mockupImageFront = null;
        let mockupImageBack = null;
        let mockupImageSide = null; // For products like caps
        let mockupImageHandle = null; // For mugs
        let currentView = 'front';

        // Check if screen is large (show both) or small (show one)
        function isLargeScreen() {
            return window.innerWidth >= 1024;
        }

        // Get the center X position for a specific view
        function getViewCenterX(view) {
            const isLarge = isLargeScreen();
            if (isLarge) {
                // Desktop: front on left, back on right
                if (view === 'front') {
                    return canvasWidth / 2 - (canvasWidth * 0.22);
                } else {
                    return canvasWidth / 2 + (canvasWidth * 0.22);
                }
            } else {
                // Mobile: always centered
                return canvasWidth / 2;
            }
        }

        // Position mockups based on screen size
        function positionMockups() {
            const isLarge = isLargeScreen();
            const viewSwitcher = document.querySelector('.m-designer-view-switcher');
            
            // Get all available mockup images
            const availableMockups = [
                { img: mockupImageFront, view: 'front' },
                { img: mockupImageBack, view: 'back' },
                { img: mockupImageSide, view: 'side' },
                { img: mockupImageHandle, view: 'handle' }
            ].filter(m => m.img !== null);
            
            if (isLarge && availableMockups.length >= 2) {
                // Hide view switcher on large screens
                viewSwitcher.style.display = 'none';
                
                // Show and position divider line in center
                if (dividerLine) {
                    dividerLine.set({
                        x1: canvasWidth / 2,
                        y1: 0,
                        x2: canvasWidth / 2,
                        y2: canvasHeight,
                        visible: true
                    });
                }
                
                // Position FRONT label on left vertical center
                if (frontLabel) {
                    frontLabel.set({
                        left: 40,
                        top: canvasHeight / 2,
                        visible: true
                    });
                }
                
                // Position BACK label on right vertical center
                if (backLabel) {
                    backLabel.set({
                        left: canvasWidth - 40,
                        top: canvasHeight / 2,
                        visible: true
                    });
                }
                
                // Show both primary mockups side by side (closer together)
                if (mockupImageFront) {
                    mockupImageFront.set({
                        left: canvasWidth / 2 - (canvasWidth * 0.22),
                        top: canvasHeight / 2,
                        visible: true
                    });
                    const scale = Math.min(
                        (canvasWidth * 0.4) / mockupImageFront.width,
                        (canvasHeight * 0.85) / mockupImageFront.height
                    );
                    mockupImageFront.scale(scale);
                }
                
                if (mockupImageBack) {
                    mockupImageBack.set({
                        left: canvasWidth / 2 + (canvasWidth * 0.22),
                        top: canvasHeight / 2,
                        visible: true
                    });
                    const scale = Math.min(
                        (canvasWidth * 0.4) / mockupImageBack.width,
                        (canvasHeight * 0.85) / mockupImageBack.height
                    );
                    mockupImageBack.scale(scale);
                }
                
                // Hide side and handle views on large screens
                if (mockupImageSide) mockupImageSide.set({ visible: false });
                if (mockupImageHandle) mockupImageHandle.set({ visible: false });
                
            } else {
                // Show view switcher on small screens or single view products
                viewSwitcher.style.display = 'flex';
                
                // Hide divider line and labels
                if (dividerLine) dividerLine.set({ visible: false });
                if (frontLabel) frontLabel.set({ visible: false });
                if (backLabel) backLabel.set({ visible: false });
                
                // Show only current view centered
                availableMockups.forEach(({ img, view }) => {
                    if (img) {
                        img.set({
                            left: canvasWidth / 2,
                            top: canvasHeight / 2,
                            visible: currentView === view
                        });
                        const scale = Math.min(
                            (canvasWidth * 0.8) / img.width,
                            (canvasHeight * 0.8) / img.height
                        );
                        img.scale(scale);
                    }
                });
            }
            
            // Reposition and filter objects based on screen size
            canvas.getObjects().forEach(obj => {
                if (obj.viewSide) {
                    const viewCenterX = getViewCenterX(obj.viewSide);
                    
                    // Store original relative position on first positioning
                    if (obj.relativeX === undefined || obj.relativeY === undefined) {
                        const currentViewCenter = isLarge ? 
                            (obj.viewSide === 'front' ? canvasWidth / 2 - (canvasWidth * 0.22) : canvasWidth / 2 + (canvasWidth * 0.22)) :
                            canvasWidth / 2;
                        obj.relativeX = obj.left - currentViewCenter;
                        obj.relativeY = obj.top - (canvasHeight / 2);
                    }
                    
                    // Apply new position based on view center
                    obj.set({
                        left: viewCenterX + obj.relativeX,
                        top: (canvasHeight / 2) + obj.relativeY
                    });
                    
                    if (isLarge) {
                        // On large screens, show all objects
                        obj.set({ visible: true });
                    } else {
                        // On small screens, only show objects for current view
                        obj.set({ visible: obj.viewSide === currentView });
                    }
                }
            });
            
            canvas.renderAll();
        }

        // Create divider line between mockups
        const dividerLine = new fabric.Line([0, 0, 0, canvasHeight], {
            stroke: '#d0d0d0',
            strokeWidth: 1,
            selectable: false,
            evented: false,
            strokeDashArray: [10, 5]
        });
        canvas.add(dividerLine);
        canvas.sendToBack(dividerLine);

        // Create FRONT label (vertical)
        const frontLabel = new fabric.Text('FRONT', {
            fontFamily: 'Mahmoud, Arial, sans-serif',
            fontSize: 48,
            fontWeight: 700,
            fill: '#000000',
            selectable: false,
            evented: false,
            originX: 'center',
            originY: 'center',
            angle: -90,
            charSpacing: 200
        });
        canvas.add(frontLabel);

        // Create BACK label (vertical)
        const backLabel = new fabric.Text('BACK', {
            fontFamily: 'Mahmoud, Arial, sans-serif',
            fontSize: 48,
            fontWeight: 700,
            fill: '#000000',
            selectable: false,
            evented: false,
            originX: 'center',
            originY: 'center',
            angle: 90,
            charSpacing: 200
        });
        canvas.add(backLabel);

        // Function to load mockup images dynamically based on product type
        function loadMockupImages(productType) {
            // Clear existing mockup images
            if (mockupImageFront) canvas.remove(mockupImageFront);
            if (mockupImageBack) canvas.remove(mockupImageBack);
            if (mockupImageSide) canvas.remove(mockupImageSide);
            if (mockupImageHandle) canvas.remove(mockupImageHandle);
            
            mockupImageFront = null;
            mockupImageBack = null;
            mockupImageSide = null;
            mockupImageHandle = null;
            
            // Get mockup configuration for this product type
            const productConfig = mockupsConfig[productType];
            if (!productConfig || !productConfig.mockups) {
                console.error('No mockup configuration found for:', productType);
                return;
            }
            
            const mockups = productConfig.mockups;
            
            // Load front view if available
            if (mockups.front) {
                fabric.Image.fromURL(mockups.front.image, function(img) {
                    mockupImageFront = img;
                    img.set({
                        selectable: false,
                        evented: false,
                        originX: 'center',
                        originY: 'center'
                    });
                    
                    canvas.add(img);
                    canvas.sendToBack(img);
                    positionMockups();
                });
            }
            
            // Load back view if available
            if (mockups.back) {
                fabric.Image.fromURL(mockups.back.image, function(img) {
                    mockupImageBack = img;
                    img.set({
                        selectable: false,
                        evented: false,
                        originX: 'center',
                        originY: 'center'
                    });
                    
                    canvas.add(img);
                    canvas.sendToBack(img);
                    positionMockups();
                });
            }
            
            // Load side view if available (for caps, etc.)
            if (mockups.side) {
                fabric.Image.fromURL(mockups.side.image, function(img) {
                    mockupImageSide = img;
                    img.set({
                        selectable: false,
                        evented: false,
                        originX: 'center',
                        originY: 'center'
                    });
                    
                    canvas.add(img);
                    canvas.sendToBack(img);
                    positionMockups();
                });
            }
            
            // Load handle view if available (for mugs)
            if (mockups.handle) {
                fabric.Image.fromURL(mockups.handle.image, function(img) {
                    mockupImageHandle = img;
                    img.set({
                        selectable: false,
                        evented: false,
                        originX: 'center',
                        originY: 'center'
                    });
                    
                    canvas.add(img);
                    canvas.sendToBack(img);
                    positionMockups();
                });
            }
            
            // Update view buttons based on available views
            updateViewButtons(mockups);
        }
        
        // Function to update view buttons based on available mockup views
        function updateViewButtons(mockups) {
            const viewSwitcher = document.querySelector('.m-designer-view-switcher');
            viewSwitcher.innerHTML = ''; // Clear existing buttons
            
            // Add buttons for each available view
            if (mockups.front) {
                const btn = document.createElement('button');
                btn.className = 'm-designer-view-btn m-designer-view-active';
                btn.setAttribute('data-view', 'front');
                btn.setAttribute('title', mockups.front.label || 'Front View');
                btn.textContent = mockups.front.label || 'Front';
                viewSwitcher.appendChild(btn);
            }
            
            if (mockups.back) {
                const btn = document.createElement('button');
                btn.className = 'm-designer-view-btn';
                btn.setAttribute('data-view', 'back');
                btn.setAttribute('title', mockups.back.label || 'Back View');
                btn.textContent = mockups.back.label || 'Back';
                viewSwitcher.appendChild(btn);
            }
            
            if (mockups.side) {
                const btn = document.createElement('button');
                btn.className = 'm-designer-view-btn';
                btn.setAttribute('data-view', 'side');
                btn.setAttribute('title', mockups.side.label || 'Side View');
                btn.textContent = mockups.side.label || 'Side';
                viewSwitcher.appendChild(btn);
            }
            
            if (mockups.handle) {
                const btn = document.createElement('button');
                btn.className = 'm-designer-view-btn';
                btn.setAttribute('data-view', 'handle');
                btn.setAttribute('title', mockups.handle.label || 'Handle View');
                btn.textContent = mockups.handle.label || 'Handle';
                viewSwitcher.appendChild(btn);
            }
            
            // Re-attach click handlers to new buttons
            attachViewButtonHandlers();
        }
        
        // Attach click handlers to view buttons
        function attachViewButtonHandlers() {
            const viewBtns = document.querySelectorAll('.m-designer-view-btn');
            viewBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    viewBtns.forEach(b => b.classList.remove('m-designer-view-active'));
                    btn.classList.add('m-designer-view-active');
                    currentView = btn.getAttribute('data-view');
                    positionMockups();
                });
            });
        }

        function renderProductDropdown() {
            const container = document.getElementById('productDropdownInner');
            container.innerHTML = '';

            const entries = Object.entries(mockupsConfig);
            const items = entries.length ? entries : [['tshirt', { name: 'T-Shirt' }]];

            items.forEach(([key, product], idx) => {
                const div = document.createElement('div');
                div.className = `m-designer-dropdown-item${idx === 0 ? ' active' : ''}`;
                div.dataset.value = key;
                div.innerHTML = `<span>${product.name || key}</span><i class="fa-sharp fa-solid fa-check m-designer-check"></i>`;
                container.appendChild(div);
            });

            attachDropdownItemHandlers();
        }

        function updateFooter() {
            const footerCopy = document.getElementById('footerCopy');
            const year = new Date().getFullYear();
            const siteName = settings.site_name || 'Djebs Official';
            if (footerCopy) {
                footerCopy.innerHTML = `&copy; ${year} ${siteName}. All rights reserved.`;
            }
        }

        // Resize canvas and mockup on window resize
        window.addEventListener('resize', () => {
            const newWidth = canvasContainer.offsetWidth;
            const newHeight = canvasContainer.offsetHeight;
            
            // Update global canvas dimensions
            canvasWidth = newWidth;
            canvasHeight = newHeight;
            
            canvas.setDimensions({ width: newWidth, height: newHeight });
            
            positionMockups();
        });

        // History for undo/redo
        let history = [];
        let historyStep = 0;

        function saveState() {
            if (historyStep < history.length) {
                history = history.slice(0, historyStep);
            }
            // Save only selectable objects (not mockups)
            const data = canvas.toJSON();
            data.objects = data.objects.filter(obj => obj.selectable !== false);
            history.push(JSON.stringify(data));
            historyStep = history.length;
        }

        // Save initial state
        saveState();

        // Product selector dropdown
        const productToggle = document.getElementById('productToggle');
        const productDropdown = document.getElementById('productDropdown');
        const productDropdownInner = document.getElementById('productDropdownInner');
        let dropdownItems = [];
        const selectedProductName = document.getElementById('selectedProductName');
        const chevron = document.querySelector('.m-designer-chevron');

        productToggle.addEventListener('click', () => {
            productDropdown.classList.toggle('active');
            chevron.style.transform = productDropdown.classList.contains('active') ? 'rotate(180deg)' : 'rotate(0deg)';
        });

        function attachDropdownItemHandlers() {
            dropdownItems = Array.from(document.querySelectorAll('.m-designer-dropdown-item'));

            dropdownItems.forEach(item => {
                item.addEventListener('click', () => {
                    dropdownItems.forEach(i => i.classList.remove('active'));
                    item.classList.add('active');

                    const text = item.querySelector('span').textContent;
                    selectedProductName.textContent = text;

                    const productType = item.getAttribute('data-value');

                    if (mockupsConfig[productType]) {
                        if (productType !== currentProductType) {
                            currentProductType = productType;
                            loadMockupImages(productType);
                        }
                    } else {
                        console.warn('Product type not found in config:', productType);
                    }

                    productDropdown.classList.remove('active');
                    chevron.style.transform = 'rotate(0deg)';
                });
            });

            const firstDropdownItem = dropdownItems[0];
            if (firstDropdownItem) {
                const firstName = firstDropdownItem.querySelector('span').textContent;
                selectedProductName.textContent = firstName;
                const firstProductType = firstDropdownItem.getAttribute('data-value');
                if (firstProductType && mockupsConfig[firstProductType]) {
                    currentProductType = firstProductType;
                    loadMockupImages(firstProductType);
                }
            }
        }

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.m-designer-product-selector')) {
                productDropdown.classList.remove('active');
                chevron.style.transform = 'rotate(0deg)';
            }
        });

        loadMockupsConfig().then(cfg => {
            mockupsConfig = cfg || {};
            renderProductDropdown();
            updateFooter();
        });

        // Tool Buttons - Add Text
        document.querySelector('[data-action="add-text"]').addEventListener('click', () => {
            const viewCenterX = getViewCenterX(currentView);
            const text = new fabric.IText('Add your text', {
                left: viewCenterX,
                top: canvasHeight / 2,
                fontFamily: 'Arial',
                fontSize: 40,
                fill: '#000000',
                originX: 'center',
                originY: 'center',
                viewSide: currentView, // Tag with current view
                relativeX: 0, // Centered relative to view
                relativeY: 0
            });
            canvas.add(text);
            canvas.setActiveObject(text);
            canvas.renderAll();
            saveState();
        });

        // Tool Buttons - Add Image
        document.querySelector('[data-action="add-image"]').addEventListener('click', () => {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = (e) => {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        fabric.Image.fromURL(event.target.result, (img) => {
                            // Calculate scale to fit image nicely in canvas (max 30% of canvas size)
                            const maxWidth = canvasWidth * 0.3;
                            const maxHeight = canvasHeight * 0.3;
                            const scale = Math.min(
                                maxWidth / img.width,
                                maxHeight / img.height,
                                1 // Don't upscale if image is already small
                            );
                            
                            const viewCenterX = getViewCenterX(currentView);
                            img.scale(scale);
                            img.set({
                                left: viewCenterX,
                                top: canvasHeight / 2,
                                originX: 'center',
                                originY: 'center',
                                viewSide: currentView, // Tag with current view
                                relativeX: 0, // Centered relative to view
                                relativeY: 0
                            });
                            canvas.add(img);
                            canvas.setActiveObject(img);
                            canvas.renderAll();
                            saveState();
                        });
                    };
                    reader.readAsDataURL(file);
                }
            };
            input.click();
        });

        // Undo functionality
        document.getElementById('undoBtn').addEventListener('click', () => {
            if (historyStep > 1) {
                historyStep--;
                const data = JSON.parse(history[historyStep - 1]);
                
                // Remove only selectable objects (keep mockups)
                canvas.getObjects().forEach(obj => {
                    if (obj.selectable !== false) {
                        canvas.remove(obj);
                    }
                });
                
                // Load saved objects
                canvas.loadFromJSON(data, () => {
                    canvas.renderAll();
                });
            }
        });

        // Redo functionality
        document.getElementById('redoBtn').addEventListener('click', () => {
            if (historyStep < history.length) {
                historyStep++;
                const data = JSON.parse(history[historyStep - 1]);
                
                // Remove only selectable objects (keep mockups)
                canvas.getObjects().forEach(obj => {
                    if (obj.selectable !== false) {
                        canvas.remove(obj);
                    }
                });
                
                // Load saved objects
                canvas.loadFromJSON(data, () => {
                    canvas.renderAll();
                });
            }
        });

        // DOWNLOAD BUTTON - Copy checkout logic and combine into one image
        document.getElementById('downloadBtn').addEventListener('click', async () => {
            console.log('🔄 Starting download...');
            
            const isMobile = !isLargeScreen();
            
            if (isMobile) {
                // MOBILE: Same as checkout - capture both views
                console.log('📱 Mobile download');
                
                const originalView = currentView;
                
                // Save original visibility state
                const originalVisibility = {};
                canvas.getObjects().forEach((obj, index) => {
                    originalVisibility[index] = obj.visible;
                });
                
                // Function to capture a specific view
                const captureView = async (viewName) => {
                    const tempCurrentView = currentView;
                    currentView = viewName;
                    
                    // Hide all mockups
                    if (mockupImageFront) mockupImageFront.visible = false;
                    if (mockupImageBack) mockupImageBack.visible = false;
                    if (mockupImageSide) mockupImageSide.visible = false;
                    if (mockupImageHandle) mockupImageHandle.visible = false;
                    
                    // Show target mockup centered
                    let targetMockup = null;
                    if (viewName === 'front' && mockupImageFront) {
                        mockupImageFront.visible = true;
                        targetMockup = mockupImageFront;
                    } else if (viewName === 'back' && mockupImageBack) {
                        mockupImageBack.visible = true;
                        targetMockup = mockupImageBack;
                    }
                    
                    // Center the mockup
                    if (targetMockup) {
                        targetMockup.set({
                            left: canvasWidth / 2,
                            top: canvasHeight / 2
                        });
                    }
                    
                    // Update object visibility and position for this view
                    canvas.getObjects().forEach(obj => {
                        if (obj.selectable !== false) {
                            if (obj.viewSide === viewName) {
                                obj.visible = true;
                                obj.set({
                                    left: (canvasWidth / 2) + (obj.relativeX || 0),
                                    top: (canvasHeight / 2) + (obj.relativeY || 0)
                                });
                            } else {
                                obj.visible = false;
                            }
                        }
                    });
                    
                    canvas.renderAll();
                    await new Promise(r => setTimeout(r, 150));
                    
                    // Capture screenshot with 2x multiplier for download
                    const screenshot = canvas.toDataURL({ format: 'png', quality: 1, multiplier: 2 });
                    
                    // Restore currentView
                    currentView = tempCurrentView;
                    
                    return screenshot;
                };
                
                // Capture both views
                let frontImage = null;
                let backImage = null;
                
                if (mockupImageFront) {
                    frontImage = await captureView('front');
                }
                
                if (mockupImageBack) {
                    backImage = await captureView('back');
                }
                
                // Restore everything to original state
                if (mockupImageFront) mockupImageFront.visible = false;
                if (mockupImageBack) mockupImageBack.visible = false;
                if (mockupImageSide) mockupImageSide.visible = false;
                if (mockupImageHandle) mockupImageHandle.visible = false;
                
                if (originalView === 'front' && mockupImageFront) mockupImageFront.visible = true;
                else if (originalView === 'back' && mockupImageBack) mockupImageBack.visible = true;
                else if (originalView === 'side' && mockupImageSide) mockupImageSide.visible = true;
                else if (originalView === 'handle' && mockupImageHandle) mockupImageHandle.visible = true;
                
                canvas.getObjects().forEach((obj, index) => {
                    if (originalVisibility[index] !== undefined) {
                        obj.visible = originalVisibility[index];
                    }
                });
                canvas.renderAll();
                
                // Combine front and back side-by-side
                const frontImg = new Image();
                const backImg = new Image();
                
                await Promise.all([
                    frontImage ? new Promise(r => { frontImg.onload = r; frontImg.src = frontImage; }) : Promise.resolve(),
                    backImage ? new Promise(r => { backImg.onload = r; backImg.src = backImage; }) : Promise.resolve()
                ]);
                
                // Create combined canvas with extra height for text and width for side labels
                const combinedCanvas = document.createElement('canvas');
                const textHeight = 180; // Space for footer text below
                const sideMargin = 120; // Space for vertical FRONT/BACK labels on sides
                combinedCanvas.width = canvas.width * 2 * 2 + (sideMargin * 2); // both views * multiplier + side margins
                combinedCanvas.height = canvas.height * 2 + textHeight;
                const ctx = combinedCanvas.getContext('2d');
                
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);
                
                // Draw images with offset for side margins
                if (frontImage) {
                    ctx.drawImage(frontImg, sideMargin, 0);
                }
                
                if (backImage) {
                    ctx.drawImage(backImg, canvas.width * 2 + sideMargin, 0);
                }
                
                // Add divider line between front and back
                ctx.strokeStyle = '#d0d0d0';
                ctx.lineWidth = 3;
                ctx.setLineDash([15, 10]);
                ctx.beginPath();
                ctx.moveTo(combinedCanvas.width / 2, 0);
                ctx.lineTo(combinedCanvas.width / 2, canvas.height * 2);
                ctx.stroke();
                ctx.setLineDash([]);
                
                // Add "FRONT" label vertically on left side
                ctx.save();
                ctx.fillStyle = '#000000';
                ctx.font = 'bold 70px Arial, sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.letterSpacing = '20px';
                ctx.translate(60, canvas.height);
                ctx.rotate(-90 * Math.PI / 180);
                ctx.fillText('FRONT', 0, 0);
                ctx.restore();
                
                // Add "BACK" label vertically on right side
                ctx.save();
                ctx.fillStyle = '#000000';
                ctx.font = 'bold 70px Arial, sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.letterSpacing = '20px';
                ctx.translate(combinedCanvas.width - 60, canvas.height);
                ctx.rotate(-90 * Math.PI / 180);
                ctx.fillText('BACK', 0, 0);
                ctx.restore();
                
                // Add timestamp text below images
                const now = new Date();
                const dateStr = now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                const timeStr = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
                
                ctx.fillStyle = '#333333';
                ctx.font = '32px Arial, sans-serif';
                ctx.textAlign = 'center';
                ctx.fillText(`Created By Djebs Official Editor on ${dateStr} at ${timeStr}`, combinedCanvas.width / 2, canvas.height * 2 + 70);
                
                // Add footer text
                ctx.fillStyle = '#666666';
                ctx.font = 'bold 28px Arial, sans-serif';
                ctx.fillText('Djebs Official Store | Made by Mahmoud', combinedCanvas.width / 2, canvas.height * 2 + 130);
                
                // Add watermark
                addWatermark(ctx, combinedCanvas.width, combinedCanvas.height);
                
                // Download
                const link = document.createElement('a');
                link.download = `design-${Date.now()}.png`;
                link.href = combinedCanvas.toDataURL('image/png');
                link.click();
                
                console.log('✅ Mobile download complete!');
                
            } else {
                // PC: Full canvas screenshot with labels and text
                console.log('💻 PC mode');
                
                const screenshot = canvas.toDataURL({ format: 'png', quality: 1, multiplier: 2 });
                
                const img = new Image();
                img.onload = () => {
                    const textHeight = 180; // Space for labels and footer
                    const finalCanvas = document.createElement('canvas');
                    finalCanvas.width = canvas.width * 2;
                    finalCanvas.height = canvas.height * 2 + textHeight;
                    const ctx = finalCanvas.getContext('2d');
                    
                    // Fill background
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
                    
                    // Draw main image
                    ctx.drawImage(img, 0, 0);
                    
                    // Add divider line in center (between front and back)
                    ctx.strokeStyle = '#d0d0d0';
                    ctx.lineWidth = 3;
                    ctx.setLineDash([15, 10]);
                    ctx.beginPath();
                    ctx.moveTo(finalCanvas.width / 2, 0);
                    ctx.lineTo(finalCanvas.width / 2, canvas.height * 2);
                    ctx.stroke();
                    ctx.setLineDash([]);
                    
                    // Add timestamp text below images
                    const now = new Date();
                    const dateStr = now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                    const timeStr = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
                    
                    ctx.fillStyle = '#333333';
                    ctx.font = '32px Arial, sans-serif';
                    ctx.textAlign = 'center';
                    ctx.fillText(`Created By Djebs Official Editor on ${dateStr} at ${timeStr}`, finalCanvas.width / 2, canvas.height * 2 + 70);
                    
                    // Add footer text
                    ctx.fillStyle = '#666666';
                    ctx.font = 'bold 28px Arial, sans-serif';
                    ctx.fillText('Djebs Official Store | Made by Mahmoud', finalCanvas.width / 2, canvas.height * 2 + 130);
                    
                    // Add watermark
                    addWatermark(ctx, finalCanvas.width, finalCanvas.height);
                    
                    const link = document.createElement('a');
                    link.download = `design-${Date.now()}.png`;
                    link.href = finalCanvas.toDataURL('image/png');
                    link.click();
                    
                    console.log('✅ PC download complete!');
                };
                img.src = screenshot;
            }
        });
        
        // Add watermark function
        function addWatermark(ctx, width, height) {
            ctx.save();
            ctx.globalAlpha = 0.08;
            ctx.fillStyle = '#000000';
            ctx.font = 'bold 36px Poppins, sans-serif';
            ctx.textAlign = 'center';
            
            const watermarkSpacingX = 300;
            const watermarkSpacingY = 150;
            
            for (let y = -100; y < height + 100; y += watermarkSpacingY) {
                for (let x = -100; x < width + 100; x += watermarkSpacingX) {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(-30 * Math.PI / 180);
                    ctx.fillText('Djebs Official-Store', 0, 0);
                    ctx.restore();
                }
            }
            ctx.restore();
        }
        
        // Helper function to add watermark pattern
        function addWatermarkPattern(ctx, width, height) {
            ctx.save();
            ctx.globalAlpha = 0.08;
            ctx.fillStyle = '#000000';
            ctx.font = 'bold 32px Arial';
            ctx.textAlign = 'center';
            
            const watermarkSpacingX = 180;
            const watermarkSpacingY = 90;
            
            for (let y = -100; y < height + 100; y += watermarkSpacingY) {
                for (let x = -100; x < width + 100; x += watermarkSpacingX) {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(-30 * Math.PI / 180);
                    ctx.fillText('Caracter', 0, 0);
                    ctx.restore();
                }
            }
            ctx.restore();
        }

        // Keyboard shortcuts
        document.addEventListener('keydown', (e) => {
            // Don't trigger shortcuts when typing in inputs or editing text
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
                return;
            }
            
            const activeObject = canvas.getActiveObject();
            
            // Delete key
            if ((e.key === 'Delete' || e.key === 'Backspace')) {
                if (activeObject && activeObject.selectable && !activeObject.isEditing) {
                    e.preventDefault();
                    document.getElementById('deleteBtn').click();
                }
            }
            
            // Undo: Ctrl+Z
            if (e.ctrlKey && e.key === 'z') {
                e.preventDefault();
                document.getElementById('undoBtn').click();
            }
            
            // Redo: Ctrl+Y or Ctrl+Shift+Z
            if ((e.ctrlKey && e.key === 'y') || (e.ctrlKey && e.shiftKey && e.key === 'z')) {
                e.preventDefault();
                document.getElementById('redoBtn').click();
            }
            
            // Duplicate: Ctrl+D
            if (e.ctrlKey && e.key === 'd') {
                e.preventDefault();
                if (activeObject && activeObject.selectable) {
                    document.getElementById('duplicateBtn').click();
                }
            }
            
            // Select All: Ctrl+A
            if (e.ctrlKey && e.key === 'a') {
                e.preventDefault();
                const objects = canvas.getObjects().filter(obj => obj.selectable);
                if (objects.length > 0) {
                    canvas.discardActiveObject();
                    const selection = new fabric.ActiveSelection(objects, { canvas });
                    canvas.setActiveObject(selection);
                    canvas.requestRenderAll();
                }
            }
        });

        // Save state after object modifications
        canvas.on('object:modified', () => {
            // Update relative position for view-specific objects
            const activeObj = canvas.getActiveObject();
            if (activeObj && activeObj.viewSide) {
                const viewCenterX = getViewCenterX(activeObj.viewSide);
                activeObj.relativeX = activeObj.left - viewCenterX;
                activeObj.relativeY = activeObj.top - (canvasHeight / 2);
            }
            saveState();
        });

        canvas.on('object:added', () => {
            if (history.length > 0) {
                // Already saved in the add functions
            }
        });

        // Color picker change - apply to t-shirt color
        const colorInput = document.getElementById('designerColorInput');
        
        function applyTshirtColor(hex) {
            // Apply color filter using multiply mode for realistic colors
            if (mockupImageFront) {
                mockupImageFront.filters = [
                    new fabric.Image.filters.BlendColor({
                        color: hex,
                        mode: 'multiply',
                        alpha: 1
                    })
                ];
                mockupImageFront.applyFilters();
            }
            
            if (mockupImageBack) {
                mockupImageBack.filters = [
                    new fabric.Image.filters.BlendColor({
                        color: hex,
                        mode: 'multiply',
                        alpha: 1
                    })
                ];
                mockupImageBack.applyFilters();
            }
            
            canvas.renderAll();
        }
        
        colorInput.addEventListener('change', (e) => {
            applyTshirtColor(e.target.value);
        });
        
        // Also listen for input event (for real-time updates)
        colorInput.addEventListener('input', (e) => {
            applyTshirtColor(e.target.value);
        });

        // Edit Bar Functionality
        const editBar = document.getElementById('editBar');
        const textTools = document.getElementById('textTools');
        const commonTools = document.getElementById('commonTools');

        // Show/hide edit bar based on selection
        canvas.on('selection:created', updateEditBar);
        canvas.on('selection:created', updateEditBar);
        canvas.on('selection:updated', updateEditBar);
        canvas.on('selection:cleared', hideEditBar);
        canvas.on('object:moving', positionEditBar);
        canvas.on('object:scaling', positionEditBar);
        canvas.on('object:rotating', positionEditBar);

        // Deselect when clicking on empty canvas area
        canvas.on('mouse:down', (e) => {
            if (!e.target) {
                canvas.discardActiveObject();
                canvas.requestRenderAll();
            }
        });

        function positionEditBar() {
            const activeObject = canvas.getActiveObject();
            if (!activeObject) return;
            
            // Get object's bounding box
            const boundingRect = activeObject.getBoundingRect();
            const canvasElement = canvas.getElement();
            const canvasRect = canvasElement.getBoundingClientRect();
            
            // Calculate position relative to viewport
            const objTop = canvasRect.top + boundingRect.top;
            const objBottom = canvasRect.top + boundingRect.top + boundingRect.height;
            const objLeft = canvasRect.left + boundingRect.left;
            const objWidth = boundingRect.width;
            
            // Edit bar dimensions (estimate)
            const barHeight = 60;
            const barWidth = editBar.offsetWidth || 600;
            const spacing = 16;
            
            // Determine if we should show above or below
            const spaceBelow = window.innerHeight - objBottom;
            const spaceAbove = objTop;
            
            let top, left;
            
            if (spaceBelow >= barHeight + spacing) {
                // Show below
                top = objBottom + spacing;
            } else if (spaceAbove >= barHeight + spacing) {
                // Show above
                top = objTop - barHeight - spacing;
            } else {
                // Not enough space, show at bottom of screen
                top = window.innerHeight - barHeight - 20;
            }
            
            // Center horizontally relative to object
            left = objLeft + (objWidth / 2) - (barWidth / 2);
            
            // Keep within viewport bounds
            const minLeft = 20;
            const maxLeft = window.innerWidth - barWidth - 20;
            left = Math.max(minLeft, Math.min(left, maxLeft));
            
            editBar.style.top = top + 'px';
            editBar.style.left = left + 'px';
        }

        function updateEditBar() {
            const activeObject = canvas.getActiveObject();
            if (activeObject && activeObject.selectable) {
                editBar.style.display = 'block';
                
                // Show/hide text-specific tools
                const isText = activeObject.type === 'i-text' || activeObject.type === 'text';
                const fontTool = document.getElementById('fontTool');
                const sizeTool = document.getElementById('sizeTool');
                const formatTool = document.getElementById('formatTool');
                const textEditBtn = document.getElementById('textEditBtn');
                const curvedBtn = document.getElementById('curvedBtn');
                
                if (fontTool) fontTool.style.display = isText ? 'flex' : 'none';
                if (sizeTool) sizeTool.style.display = isText ? 'flex' : 'none';
                if (formatTool) formatTool.style.display = isText ? 'flex' : 'none';
                if (textEditBtn) textEditBtn.style.display = isText ? 'flex' : 'none';
                if (curvedBtn) curvedBtn.style.display = isText ? 'flex' : 'none';
                
                if (isText) {
                    updateTextControls(activeObject);
                }
                
                updateCommonControls(activeObject);
                
                // Position the edit bar near the object
                setTimeout(() => {
                    positionEditBar();
                    editBar.classList.add('show');
                }, 10);
            } else {
                hideEditBar();
            }
        }

        function hideEditBar() {
            editBar.classList.remove('show');
            setTimeout(() => {
                editBar.style.display = 'none';
            }, 200);
            // Hide all panels when edit bar is hidden
            document.getElementById('transformPanel').style.display = 'none';
            document.getElementById('positionPanel').style.display = 'none';
            document.getElementById('fontPanel').style.display = 'none';
            fontFamilyBtn.classList.remove('open');
        }

        // --- Center guide and snapping ---
        // Guide lines (horizontal and vertical)
        let centerGuideV = null;
        let centerGuideH = null;
        const snapThreshold = 30; // pixels

        function ensureGuides() {
            if (!centerGuideV) {
                centerGuideV = new fabric.Line([0, 0, 0, canvasHeight], {
                    stroke: 'rgba(0,0,0,0.7)',
                    strokeWidth: 1,
                    selectable: false,
                    evented: false,
                    strokeDashArray: [6, 4]
                });
                canvas.add(centerGuideV);
            }
            if (!centerGuideH) {
                centerGuideH = new fabric.Line([0, 0, canvasWidth, 0], {
                    stroke: 'rgba(0,0,0,0.7)',
                    strokeWidth: 1,
                    selectable: false,
                    evented: false,
                    strokeDashArray: [6, 4]
                });
                canvas.add(centerGuideH);
            }
        }

        function hideGuides() {
            if (centerGuideV) centerGuideV.set({ visible: false });
            if (centerGuideH) centerGuideH.set({ visible: false });
            canvas.renderAll();
        }

        function showGuidesAt(x, y, showV, showH) {
            ensureGuides();
            if (centerGuideV) {
                centerGuideV.set({ x1: x, x2: x, y1: 0, y2: canvasHeight, visible: !!showV });
            }
            if (centerGuideH) {
                centerGuideH.set({ y1: y, y2: y, x1: 0, x2: canvasWidth, visible: !!showH });
            }
            canvas.bringToFront(centerGuideV);
            canvas.bringToFront(centerGuideH);
            canvas.renderAll();
        }

        // Determine the current mockup center (for snapping)
        function getActiveMockupCenter(obj) {
            // prefer the mockup the object is closest to
            const candidates = [];
            if (mockupImageFront && mockupImageFront.visible) candidates.push(mockupImageFront);
            if (mockupImageBack && mockupImageBack.visible) candidates.push(mockupImageBack);

            if (candidates.length === 0) return { x: canvasWidth / 2, y: canvasHeight / 2 };

            // object center
            const ox = obj.left || (obj.getCenterPoint && obj.getCenterPoint().x) || obj.oCoords && obj.oCoords.tl.x;
            const oy = obj.top || (obj.getCenterPoint && obj.getCenterPoint().y) || obj.oCoords && obj.oCoords.tl.y;

            let best = candidates[0];
            let bestDist = Infinity;
            candidates.forEach(mp => {
                const dx = (mp.left || canvasWidth/2) - ox;
                const dy = (mp.top || canvasHeight/2) - oy;
                const d = Math.sqrt(dx*dx + dy*dy);
                if (d < bestDist) { bestDist = d; best = mp; }
            });

            return { x: best.left || canvasWidth/2, y: best.top || canvasHeight/2 };
        }

        // During move, show guides when near center
        canvas.on('object:moving', (e) => {
            const obj = e.target;
            if (!obj) return;
            const center = getActiveMockupCenter(obj);

            // Get object's center point
            const objCenter = obj.getCenterPoint();
            const dx = Math.abs(objCenter.x - center.x);
            const dy = Math.abs(objCenter.y - center.y);

            const showV = dx <= snapThreshold;
            const showH = dy <= snapThreshold;

            if (showV || showH) {
                showGuidesAt(center.x, center.y, showV, showH);
            } else {
                hideGuides();
            }
        });

        // On object modified (drop), snap if within threshold
        canvas.on('object:modified', (e) => {
            const obj = e.target;
            if (!obj) return;
            const center = getActiveMockupCenter(obj);
            
            // Get object's center point
            const objCenter = obj.getCenterPoint();
            const dx = Math.abs(objCenter.x - center.x);
            const dy = Math.abs(objCenter.y - center.y);

            let moved = false;
            if (dx <= snapThreshold) {
                obj.set('left', center.x);
                moved = true;
            }
            if (dy <= snapThreshold) {
                obj.set('top', center.y);
                moved = true;
            }
            if (moved) {
                obj.setCoords();
                canvas.renderAll();
                saveState();
            }
            hideGuides();
        });

        // Panel toggles
        const formatBtn = document.getElementById('formatBtn');
        const formatPanel = document.getElementById('formatPanel');
        const transformBtn = document.getElementById('transformBtn');
        const transformPanel = document.getElementById('transformPanel');
        const positionBtn = document.getElementById('positionBtn');
        const positionPanel = document.getElementById('positionPanel');
        const colorPickerInput = document.getElementById('colorPickerInput');
        const fontFamilyBtn = document.getElementById('fontFamilyBtn');
        const fontPanel = document.getElementById('fontPanel');

        if (formatBtn) {
            formatBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                const isVisible = formatPanel.style.display === 'flex';
                formatPanel.style.display = isVisible ? 'none' : 'flex';
                transformPanel.style.display = 'none';
                positionPanel.style.display = 'none';
                fontPanel.style.display = 'none';
                if (!isVisible) positionPanelInBounds(formatPanel, formatBtn);
            });
        }

        transformBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const isVisible = transformPanel.style.display === 'flex';
            transformPanel.style.display = isVisible ? 'none' : 'flex';
            if (formatPanel) formatPanel.style.display = 'none';
            positionPanel.style.display = 'none';
            fontPanel.style.display = 'none';
            if (!isVisible) positionPanelInBounds(transformPanel, transformBtn);
        });

        positionBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const isVisible = positionPanel.style.display === 'flex';
            positionPanel.style.display = isVisible ? 'none' : 'flex';
            if (formatPanel) formatPanel.style.display = 'none';
            transformPanel.style.display = 'none';
            fontPanel.style.display = 'none';
            if (!isVisible) positionPanelInBounds(positionPanel, positionBtn);
        });

        // Font selector toggle
        fontFamilyBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const isVisible = fontPanel.style.display === 'block';
            fontPanel.style.display = isVisible ? 'none' : 'block';
            fontFamilyBtn.classList.toggle('open', !isVisible);
            if (formatPanel) formatPanel.style.display = 'none';
            transformPanel.style.display = 'none';
            positionPanel.style.display = 'none';
            if (!isVisible) positionPanelInBounds(fontPanel, fontFamilyBtn);
        });

        // Function to keep panels within canvas bounds
        function positionPanelInBounds(panel, button) {
            setTimeout(() => {
                const panelRect = panel.getBoundingClientRect();
                const canvasSection = document.querySelector('.m-designer-section');
                const sectionRect = canvasSection.getBoundingClientRect();
                
                // Check if panel goes outside left
                if (panelRect.left < sectionRect.left) {
                    const offset = sectionRect.left - panelRect.left + 10;
                    panel.style.left = `calc(50% + ${offset}px)`;
                }
                
                // Check if panel goes outside right
                if (panelRect.right > sectionRect.right) {
                    const offset = panelRect.right - sectionRect.right + 10;
                    panel.style.left = `calc(50% - ${offset}px)`;
                }
                
                // Check if panel goes outside top
                if (panelRect.top < sectionRect.top) {
                    panel.style.bottom = 'auto';
                    panel.style.top = 'calc(100% + 0.5rem)';
                }
            }, 10);
        }

        // Font item selection
        document.querySelectorAll('.m-designer-font-item').forEach(item => {
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                const font = item.getAttribute('data-font');
                const activeObject = canvas.getActiveObject();
                if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                    activeObject.set('fontFamily', font);
                    document.getElementById('selectedFont').textContent = font;
                    
                    // Update active state
                    document.querySelectorAll('.m-designer-font-item').forEach(i => i.classList.remove('active'));
                    item.classList.add('active');
                    
                    canvas.renderAll();
                    saveState();
                    fontPanel.style.display = 'none';
                    fontFamilyBtn.classList.remove('open');
                }
            });
        });
        

        // Close panels when clicking outside
        document.addEventListener('click', (e) => {
            if (formatPanel && !e.target.closest('#formatBtn') && !e.target.closest('#formatPanel')) {
                formatPanel.style.display = 'none';
            }
            if (!e.target.closest('#transformBtn') && !e.target.closest('#transformPanel')) {
                transformPanel.style.display = 'none';
            }
            if (!e.target.closest('#positionBtn') && !e.target.closest('#positionPanel')) {
                positionPanel.style.display = 'none';
            }
            if (!e.target.closest('#fontFamilyBtn') && !e.target.closest('#fontPanel')) {
                fontPanel.style.display = 'none';
                fontFamilyBtn.classList.remove('open');
            }
        });

        // Mahmoud color picker change event (listen to hidden input)
        colorPickerInput.addEventListener('input', (e) => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                const color = e.target.value;
                activeObject.set('fill', color);
                canvas.renderAll();
                saveState();
            }
        });

        // Text edit button allows editing text content
        document.getElementById('textEditBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                activeObject.enterEditing();
                activeObject.selectAll();
                canvas.renderAll();
            }
        });

        // Center buttons handlers
        function centerActiveObject(axis) {
            const obj = canvas.getActiveObject();
            if (!obj) return;
            const center = getActiveMockupCenter(obj);
            
            // Center the object using its center point
            if (axis === 'h' || axis === 'both') {
                obj.set('left', center.x);
            }
            if (axis === 'v' || axis === 'both') {
                obj.set('top', center.y);
            }
            
            obj.setCoords();
            canvas.renderAll();
            saveState();
        }

        document.getElementById('centerHorizBtn').addEventListener('click', () => centerActiveObject('h'));
        document.getElementById('centerVertBtn').addEventListener('click', () => centerActiveObject('v'));
        document.getElementById('centerBothBtn').addEventListener('click', () => centerActiveObject('both'));

        // Text Tools
        function updateTextControls(obj) {
            const textColor = obj.fill || '#000000';
            const fontFamily = obj.fontFamily || 'Arial';
            
            // Update font selector
            document.getElementById('selectedFont').textContent = fontFamily;
            document.querySelectorAll('.m-designer-font-item').forEach(item => {
                item.classList.toggle('active', item.getAttribute('data-font') === fontFamily);
            });
            
            document.getElementById('fontSize').value = obj.fontSize || 40;
            
            // Update mahmoud color picker
            colorPickerInput.value = textColor;
            
            document.getElementById('boldBtn').classList.toggle('active', obj.fontWeight === 'bold');
            document.getElementById('italicBtn').classList.toggle('active', obj.fontStyle === 'italic');
            document.getElementById('underlineBtn').classList.toggle('active', obj.underline === true);
        }

        function updateCommonControls(obj) {
            const opacity = Math.round((obj.opacity || 1) * 100);
            document.getElementById('opacitySlider').value = opacity;
            document.getElementById('opacityValue').textContent = opacity + '%';
        }

        // Font Size
        document.getElementById('fontSize').addEventListener('change', (e) => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                activeObject.set('fontSize', parseInt(e.target.value));
                canvas.renderAll();
                saveState();
            }
        });

        // Bold
        document.getElementById('boldBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                const isBold = activeObject.fontWeight === 'bold';
                activeObject.set('fontWeight', isBold ? 'normal' : 'bold');
                document.getElementById('boldBtn').classList.toggle('active', !isBold);
                canvas.renderAll();
                saveState();
            }
        });

        // Italic
        document.getElementById('italicBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                const isItalic = activeObject.fontStyle === 'italic';
                activeObject.set('fontStyle', isItalic ? 'normal' : 'italic');
                document.getElementById('italicBtn').classList.toggle('active', !isItalic);
                canvas.renderAll();
                saveState();
            }
        });

        // Underline
        document.getElementById('underlineBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                const isUnderline = activeObject.underline === true;
                activeObject.set('underline', !isUnderline);
                document.getElementById('underlineBtn').classList.toggle('active', !isUnderline);
                canvas.renderAll();
                saveState();
            }
        });

        // Curved Text / Effects button (placeholder for future effects)
        document.getElementById('curvedBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && (activeObject.type === 'i-text' || activeObject.type === 'text')) {
                // Toggle curved text effect (simple example)
                const currentSpacing = activeObject.charSpacing || 0;
                if (currentSpacing === 0) {
                    activeObject.set('charSpacing', 100);
                } else {
                    activeObject.set('charSpacing', 0);
                }
                canvas.renderAll();
                saveState();
            }
        });

        // Duplicate
        document.getElementById('duplicateBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject) {
                activeObject.clone((cloned) => {
                    cloned.set({
                        left: cloned.left + 20,
                        top: cloned.top + 20
                    });
                    canvas.add(cloned);
                    canvas.setActiveObject(cloned);
                    canvas.renderAll();
                    saveState();
                });
            }
        });

        // Bring Forward / Send Backward
        document.getElementById('bringForwardBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject) {
                canvas.bringForward(activeObject);
                canvas.renderAll();
                saveState();
            }
        });

        document.getElementById('sendBackwardBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject) {
                canvas.sendBackwards(activeObject);
                canvas.renderAll();
                saveState();
            }
        });

        // Flip Horizontal / Vertical
        document.getElementById('flipHBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject) {
                activeObject.set('flipX', !activeObject.flipX);
                canvas.renderAll();
                saveState();
            }
        });

        document.getElementById('flipVBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject) {
                activeObject.set('flipY', !activeObject.flipY);
                canvas.renderAll();
                saveState();
            }
        });

        // Opacity
        document.getElementById('opacitySlider').addEventListener('input', (e) => {
            const activeObject = canvas.getActiveObject();
            if (activeObject) {
                const opacity = parseInt(e.target.value) / 100;
                activeObject.set('opacity', opacity);
                document.getElementById('opacityValue').textContent = e.target.value + '%';
                canvas.renderAll();
            }
        });

        document.getElementById('opacitySlider').addEventListener('change', () => {
            saveState();
        });

        // Delete
        document.getElementById('deleteBtn').addEventListener('click', () => {
            const activeObject = canvas.getActiveObject();
            if (activeObject && activeObject.selectable) {
                // Remove the object first
                canvas.remove(activeObject);
                // Then discard the selection
                canvas.discardActiveObject();
                // Force render
                canvas.requestRenderAll();
                // Hide the edit bar
                hideEditBar();
                // Save state
                saveState();
            }
        });
    